import styled from 'styled-components';

export const StyledSpatialReferenceHelperText = styled.div`
  font-size: 0.8125rem;
  line-height: 1.55rem;
`;
